export const getCurrentPageData = (fileData: any, pageNumber: number) => {
  if (!fileData) return null;
  if (fileData.page_data.page_number === pageNumber - 1) {
    return fileData.page_data;
  }
  return null;
};

export const clearCanvas = (canvasRef: React.RefObject<HTMLCanvasElement>) => {
  if (canvasRef.current) {
    const ctx = canvasRef.current.getContext('2d');
    if (ctx) {
      ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    }
  }
};
